import { render, staticRenderFns } from "./AddAdditionalPayment.vue?vue&type=template&id=330ed68c"
import script from "./AddAdditionalPayment.vue?vue&type=script&lang=js"
export * from "./AddAdditionalPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports